import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'how_many_workers_became_disabled_whatever_reason'

export const dataPointDefinition = {
  retracedId: 'how_many_workers_became_disabled_whatever_reason',
  name: 'How many workers became disabled (for whatever reason)?',
  description:
    'The intent of this question is to understand if the facility has had any workers who have become disabled either as a result of the job OR for another reason (for example, an incident off-site of the facility during non-working time). ',
  meta: {
    slcpMeta: {
      key: 'disc-9--2',
      number: 'WT-DIS-17',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'disc-9--2', version: '1.7.0', provider: 'slcp'}],
  sortingId: 26920,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
